import baseConfiguratorReducer from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer";
import { RECEIVE_SWITCHOPTIONSRESULT } from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import {
  SET_CONFIGURATION_LEVEL,
  SET_CONFIGURATION_OPTIONCLASSIFICATIONS,
  SET_ORIGINAL_CONFIGURATION,
} from "./Actions";
import { hasDesign, isOriginalConfiguration } from "./Selectors";

interface IAction {
  type?: string;
  [key: string]: any;
}

export default function configuratorReducer(
  state = baseConfiguratorReducer(),
  action: IAction = {}
) {
  switch (action.type) {
    case SET_ORIGINAL_CONFIGURATION: {
      const { originalConfiguration } = action;
      const isOriginal = isOriginalConfiguration(
        originalConfiguration,
        state.configuration
      );
      return {
        ...state,
        originalConfiguration,
        isOriginal,
      };
    }
    case RECEIVE_SWITCHOPTIONSRESULT: {
      const nextState = baseConfiguratorReducer(state, action);
      const isOriginal = isOriginalConfiguration(
        nextState.originalConfiguration,
        nextState.configuration
      );
      return {
        ...nextState,
        isOriginal,
      };
    }
    case SET_CONFIGURATION_LEVEL: {
      const newState = baseConfiguratorReducer(state, action);
      return {
        ...newState,
        configuration: {
          ...newState.configuration,
          customdata: {
            ...newState.configuration.customdata,
            level_visibility: action.level_visibility,
          },
        },
      };
    }
    case SET_CONFIGURATION_OPTIONCLASSIFICATIONS: {
      const newState = baseConfiguratorReducer(state, action);
      return {
        ...newState,
        filteredOptionclassifications: action.optionclassifications,
        optionclassifications: action.optionclassifications,

      };
    }
  }
  const nextState = baseConfiguratorReducer(state, action);
  if (nextState.configuration !== state.configuration) {
    return {
      ...nextState,
      hasDesign: hasDesign(nextState.configuration),
    };
  }
  return nextState;
}
